// public/js/modules/timeSync.js

let clockOffset = 0;


export async function syncClock() {
    try {
        const clientSendTime = Date.now();
        
        const response = await fetch('https://us-east1-f8lyss-music-app-63fb7.cloudfunctions.net/getServerTime');
        const data = await response.json();
        const clientReceiveTime = Date.now();

        const serverTime = data.serverTime;
        const latency = (clientReceiveTime - clientSendTime) / 2;
        const estimatedServerTimeAtReceive = serverTime + latency;
        
        clockOffset = estimatedServerTimeAtReceive - clientReceiveTime;
        console.log(`Clock synchronized. Offset to server is ${clockOffset.toFixed(0)}ms.`);

    } catch (error) {
        console.error("Failed to sync clock with server:", error);
        
        clockOffset = 0;
    }
}


export function getClockOffset() {
    return clockOffset;
}


export function getEstimatedServerTime() {
    return Date.now() + clockOffset;
}